import findItemByKey from '@/helpers/findItemByKey';
import findSelectedKeys from '@/helpers/findSelectedKeys';
import { User } from '@/redux/auth/authTypes';
import { Layout, Menu, Tooltip, Typography } from 'antd';
import { MenuProps } from 'antd/lib';
import { useCallback, useState } from 'react';
import { FaMobile, FaStore } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';

const { Sider } = Layout;
const { Text } = Typography;

interface SidebarLayoutProps {
  items: any[];
  user: User | null;
}

const SidebarLayout = ({ items, user }: SidebarLayoutProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 1024);

  const selectedKeys = findSelectedKeys(location.pathname, items);

  const handleMenuItemSelect: MenuProps['onSelect'] = useCallback(
    (e: any) => {
      const selectedItem = findItemByKey(e.key, items);
      if (selectedItem?.url) navigate(selectedItem.url);
    },
    [items, navigate]
  );

  return (
    <Sider
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={(val) => setCollapsed(val)}
      width={180}
      collapsedWidth={56}
      className="flex flex-col bg-[var(--bg-clr)] shadow-md"
    >
      {/* User Profile */}
      <div
        className={`${collapsed ? 'p-2' : 'p-2.5'} bg-cover bg-center relative border-b border-white/10`}
        style={{
          backgroundImage:
            'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0,0,0,0.7)), url(/assets/img/login.jpeg)',
        }}
      >
        {!collapsed && (
          <div className="flex flex-col gap-2">
            <div className="flex flex-col">
              <Text strong className="text-white text-sm truncate">
                {user?.name}
              </Text>
              <Text className="text-white/80 text-xs">Cashier</Text>
            </div>
            <div className="bg-white/10 rounded-lg p-2">
              <div className="flex items-center gap-1.5 mb-1">
                <FaStore size={12} className="text-white opacity-70" />
                <Text className="text-white text-xs font-medium truncate">
                  {user?.activeStore?.name}
                </Text>
              </div>
              <div className="flex items-center gap-1.5">
                <FaMobile size={12} className="text-white opacity-70" />
                <Text className="text-white text-xs font-medium truncate">
                  {user?.devicePOS?.name}
                </Text>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Navigation */}
      <div className="flex-1 overflow-auto">
        <Menu
          mode="inline"
          selectedKeys={selectedKeys}
          className="border-0 py-2"
          items={items.map((item) => ({
            ...item,
            label: collapsed ? <Tooltip title={item.label}>{item.label}</Tooltip> : item.label,
          }))}
          onSelect={handleMenuItemSelect}
        />
      </div>
    </Sider>
  );
};

export default SidebarLayout;
